var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaquete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Send_package",
    "data-name": "Send package"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.5 44.126a1.989 1.989 0 0 0 -1 .008l-15.921 4.266a2.987 2.987 0 0 0 -2.094 2.061l-10.675-6.161a3 3 0 0 0 -3 5.2l17.726 10.232a2 2 0 0 0 1 .268h16.992a2 2 0 0 0 .894-.211l3.578-1.789v-12z",
    fill: "#ffbcab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 11h14l2-8h-12z",
    fill: "#a97c50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 11-4-8h-12l2 8z",
    fill: "#a97c50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 43h-8v3 12 3h8v-2-14z",
    fill: "#006df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 45h8v14h-8z",
    fill: "#2488ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 11h36v28h-36z",
    fill: "#bc9977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 21 4 2v-12h-8v12z",
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 11-2-8h-4l-2 8z",
    fill: "#ee8700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 11v18a6 6 0 0 1 -6 6h-28v4h36v-28z",
    fill: "#b38b63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 45h2v14h-2z",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.132 53.2a3 3 0 0 1 -3.674-2.121c-.027-.1-.032-.2-.049-.3a2.985 2.985 0 0 0 3.723 3.421l11.693-3.133-.361-.9z",
    fill: "#ff9478"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaquete);
export default __webpack_public_path__ + "static/media/paquete.d0eaeeecf9208f48743a0c56f6a21bfb.svg";
export { ForwardRef as ReactComponent };